import { useContext, useState, useEffect, useCallback } from 'react'

// api references
import { apiClient } from 'utils/api/apiClient'

// Soft UI Dashboard PRO React components
import DashboardLayout from 'components/LayoutContainers/DashboardLayout'

// Data
import { selectData } from 'layouts/onboarding'
import { IntakeContext } from 'context/IntakeContext'

// Popup
import { toast } from 'react-toastify'
import { useFormDebounce } from 'hooks/useFormDebounce'
import { Box, Grid, Typography } from '@mui/material'
import LoadingButton from 'components/LoadingButton'
import SlideDeck from './components/SlideDeck'
import { Heading, Text, Slide } from 'spectacle'

const FinancialFrameworkCreator = () => {
  const {
    intakeState,
    updateIntakeStateAtKey,
    updateUser,
    userTasks,
    currentErrors,
    isAdmin,
  } = useContext(IntakeContext)

  const { updateIntakeStateAndSubmit, loading } = useFormDebounce()

  const slides = [
    <>
      <Heading color="primary">Hello There!</Heading>
      <Text>Welcome to the embedded presentation</Text>
    </>,
    <>
      <Heading>Dynamic Slide</Heading>
      <Text>You can generate this from data, props, etc.</Text>
    </>,
    <>
      <Heading>Thanks!</Heading>
      <Text>Drop your questions below.</Text>
    </>,
  ]

  return (
    <DashboardLayout>
      <Box
        px={{
          xs: 4,
          sm: 4,
          md: 4,
          lg: 6,
          xl: 6,
          xxl: 6,
          test: 6,
          xl3: 6,
        }}
      >
        <Grid item xs={12} mb={1} mt={4}>
          <Typography
            variant="h1"
            fontWeight="600"
            fontSize="28px"
            textAlign="left"
            color="#262627"
          >
            Financial Framework Creator
          </Typography>
        </Grid>
      </Box>
      <Grid container spacing={2} p={2}>
        <Box
          sx={{
            position: 'fixed',
            top: '10px',
            right: 16,
            padding: '5px',
            backgroundColor: '#fff',
            boxShadow: '0px 4px 25px -8px rgba(0,0,0,0.2)',
            borderRadius: '8px',
            zIndex: 1,
          }}
        >
          <LoadingButton loading={loading} sx={{ padding: '8px 24px' }} />
        </Box>
        <Box sx={{ backgroundColor: 'red' }}>
          <SlideDeck slides={slides} />
        </Box>
      </Grid>
    </DashboardLayout>
  )
}

export default FinancialFrameworkCreator
